export const LEVEL = {
  QUALIFYING: 'qualifying',
  LEVEL_1: 'level1',
  LEVEL_2: 'level2',
  LEVEL_3: 'level3',
}

export const CURRICULUM_VERSION = {
  V3_0: '3.0',
  V3_1: '3.1',
}

export const LEVEL_ORDER = [
  LEVEL.QUALIFYING,
  LEVEL.LEVEL_1,
  LEVEL.LEVEL_2,
  LEVEL.LEVEL_3,
]

export const REQUIREMENT = {
  // Exclusive to Qualifying
  BACKGROUND_CHECK: 'background_check',
  PLAYING_ABILITY_TEST: 'playing_ability_test',
  COURSE_MANUALS: 'course_manuals',
  APPLICATION: 'application',

  // Exclusive to Level 1
  VIRTUAL_SEMINAR: 'virtual_seminar',
  
  // Shared between Levels 1-2
  PURCHASE: 'purchase',

  // Shared between Levels 1-3
  SEMINAR: 'seminar',
  PORTFOLIO: 'portfolio',

  // Exclusive to Level 3
  FINAL_EXAM: 'final_exam',
  ENROLLMENT: 'enrollment',
}

// PAT Warning Messages (separate from standard requirement statuses)
// These are used when PAT is incomplete but user has advanced past Qualifying
export const PAT_WARNING_MESSAGES = {
  BANNER: 'In order to enroll as a PGA Member, a passing score is still required.',
  DESCRIPTION: 'Congratulations, you have qualifying scores and can advance to Level 1. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.',
}
